module.exports = __webpack_public_path__ + "avab.4a7ba57335571de59f5d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/avab.woff2
// module id = ./src/assets/webfonts/avab.woff2
// module chunks = styles